<template>
  <div class="video-grid" id="video">
    <div class="video-view">
      <div id="localStream" class="video-placeholder"></div>
      <canvas style="display:none;" id="canvasAgoraCamera" :width="photoWidth" :height="photoHeight"></canvas>
    </div>
    <p
      class="text"
      @click="changeVideo"
      :style='{ background: `${hexToRgba($store.state.theme.themeColor, 0.8)}` }'
    >
      <icon-camera class="icon-camera"></icon-camera>点击切换摄像头
    </p>
    <div v-if="loading" class="loading">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="20"
        :color="$store.state.theme.themeColor.split(';')[0]"
      />
    </div>
  </div>
</template>

<script>
import AgoraRTC from 'agora-rtc-sdk'
import { get, post } from '@/utils/ajax'
import { qiniuUpload } from '@/utils'
import IconCamera from '@/assets/svg/icon-camera-change.svg'
import cameraErrorTips from './cameraErrorTips.json'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'

export default {
  components: {
    IconCamera,
    LoopingRhombusesSpinner
  },
  props: {
    userId: {
      type: Number
    },
    option: {
      type: Object
    },
    openPhotoMonitor: {
      type: Boolean
    }
  },
  data() {
    return {
      examId: null,
      rtc: {
        client: null,
        joined: false,
        published: false,
        localStream: null,
        remoteStreams: [],
        params: {}
      },
      statusTimer: null,
      agoraInfo: {},
      agoraStatus: {},
      errorTimes: 0,
      photoWidth: 420,
      photoHeight: 280,
      photoTimer: null,
      videoStatusTimer: null,
      getRecordTimer: null,
      isPublish: false,
      videos: [],
      audios: [],
      videoId: null,
      audioId: null,
      showDeviceSelect: false,
      videoIndex: 0,
      loading: false
    }
  },
  async mounted() {
    this.examId = localStorage.examId
    // 创建一个客户端对象
    this.rtc.client = AgoraRTC.createClient({ mode: 'rtc', codec: 'h264' })
    this.handleEvents()
  },
  destroyed() {
    this.closeTimer()
    if (this.isPublish && this.$store.state.user) {
      this.leave()
    }
  },
  watch: {
    option(val) {
      this.getDevices()
    },
    openPhotoMonitor(val) {
      if (val && this.isPublish) { // 打开AI拍照监控
        // 设置定时器，一分钟拍照上报一次
        const _this = this
        this.photoTimer = setInterval(() => {
          _this.setImage() // 拍照
        }, 60000)
      } else {
        clearInterval(this.photoTimer)
        this.photoTimer = null
      }
    }
  },
  methods: {
    // 初始化一个客户端对象
    init() {
      const _this = this
      this.rtc.client.init(this.option.appId, function () {
        _this.rtcClientJoin()
      }, (err) => {
        console.error('rtc error', err)
      })
    },
    // 加入频道
    rtcClientJoin() {
      const _this = this
      this.rtc.client.join(this.option.token ? this.option.token : null, this.option.channel, this.option.uid ? +this.option.uid : null, function (uid) {
        console.log('join channel:' + _this.option.channel + ' success, uid: ' + uid)
        _this.rtc.params.uid = uid
        _this.createLocalStream()
      }, function(err) {
        console.error('client join failed', err)
      })
    },
    // 创建一个本地音视频流并初始化
    createLocalStream() {
      this.rtc.localStream = AgoraRTC.createStream({
        streamID: this.rtc.params.uid,
        audio: true,
        video: true,
        screen: false,
        cameraId: this.videoId
      })
      const _this = this
      this.rtc.localStream.setVideoProfile('720p')
      this.rtc.localStream.init(function () {
        console.log('init local stream success')
        // play stream with html element id "localStream"
        _this.rtc.localStream.play('localStream', { fit: 'cover' })
        _this.publishStream()
        // _this.isPublish = true
      }, function (err) {
        console.error('init local stream failed', err)
        _this.$emit('cameraError', err)
      })
    },
    // 发布本地流
    publishStream() {
      const _this = this
      this.rtc.client.publish(this.rtc.localStream, function (err) {
        console.log('publish failed')
        console.error(err)
        _this.isPublish = false
      })
    },
    // 断开流
    leave() {
      const _this = this
      // Leave the channel
      this.rtc.client.leave(function () {
        // Stop playing the local stream
        _this.rtc.localStream.stop()
        // Close the local stream
        _this.rtc.localStream.close()
        // Stop playing the remote streams and remove the views
        console.log(_this.rtc.remoteStreams.length)
        while (_this.rtc.remoteStreams.length > 0) {
          const stream = _this.rtc.remoteStreams.shift()
          const id = stream.getId()
          stream.stop()
          this.removeView(id)
        }
        console.log('client leaves channel success')
        _this.reportLeave()
      }, function (err) {
        console.log('channel leave failed')
        console.error(err)
      })
    },
    handleEvents() {
      const _client = this.rtc.client
      _client.on('error', (err) => {
        console.log(err)
      })
      // Occurs when the peer user leaves the channel; for example, the peer user calls Client.leave.
      _client.on('peer-leave', (evt) => {
        const id = evt.uid
        const streams = this._remoteStreams.filter(e => id !== e.getId())
        const peerStream = this._remoteStreams.find(e => id === e.getId())
        peerStream && peerStream.stop()
        this._remoteStreams = streams
        if (id !== this._params.uid) {
          this.removeView(id)
        }
        console.log('peer-leave', id)
      })
      // Occurs when the local stream is _published.
      _client.on('stream-published', () => {
        console.log('stream-published')
        this.isPublish = true
        // 设置圆角
        document.getElementById(`player_${this.option.uid}`).style.borderRadius = '8px'
        this.reportStartVideo()
        if (this.openPhotoMonitor) { // 打开AI拍照监控
          // 设置定时器，一分钟拍照上报一次
          const _this = this
          this.photoTimer = setInterval(() => {
            _this.setImage() // 拍照
          }, 60000)
        } else {
          clearInterval(this.photoTimer)
          this.photoTimer = null
        }
      })
      // Occurs when the remote stream is added.
      _client.on('stream-added', (evt) => {
        const remoteStream = evt.stream
        const id = remoteStream.getId()
        console.log('stream-added uid: ' + id)
        if (id !== this._params.uid) {
          this._client.subscribe(remoteStream, (err) => {
            console.log('stream subscribe failed', err)
          })
        }
        console.log('stream-added remote-uid: ', id)
      })
      // Occurs when a user subscribes to a remote stream.
      _client.on('stream-subscribed', (evt) => {
        const remoteStream = evt.stream
        const id = remoteStream.getId()
        this._remoteStreams.push(remoteStream)
        this.addView(id)
        remoteStream.play('remote_video_' + id, { fit: 'cover' })
        console.log('stream-subscribed remote-uid: ', id)
      })
      // Occurs when the remote stream is removed; for example, a peer user calls Client.unpublish.
      _client.on('stream-removed', (evt) => {
        const remoteStream = evt.stream
        const id = remoteStream.getId()
        console.log('stream-removed uid: ' + id)
        remoteStream.stop()
        this._remoteStreams = this._remoteStreams.filter((stream) => {
          return stream.getId() !== id
        })
        this.removeView(id)
        console.log('stream-removed remote-uid: ', id)
      })
      _client.on('onTokenPrivilegeWillExpire', () => {
        // After requesting a new token
        // this._client.renewToken(token);
        console.log('onTokenPrivilegeWillExpire')
      })
      _client.on('onTokenPrivilegeDidExpire', () => {
        // After requesting a new token
        // client.renewToken(token);
        console.log('onTokenPrivilegeDidExpire')
      })
    },
    addView (id) {
      const item = document.getElementById(id)
      const video = document.getElementById('video')
      if (!item[0]) {
        const oDiv1 = document.createElement('div')
        oDiv1.id = 'remote_video_panel_' + id
        oDiv1.class = 'video-view'
        video.appendChild(oDiv1)
        // $("<div/>", {
        //   id: "remote_video_panel_" + id,
        //   class: "video-view",
        // }).appendTo('#video')

        const oDiv2 = document.createElement('div')
        oDiv2.id = 'remote_video_' + id
        oDiv2.class = 'video-placeholder'
        oDiv1.appendChild(oDiv2)
        // $("<div/>", {
        //   id: "remote_video_" + id,
        //   class: "video-placeholder",
        // }).appendTo("#remote_video_panel_" + id)
      }
    },
    removeView (id) {
      const item = document.getElementById('remote_video_panel_' + id)
      if (item[0]) {
        item.remove()
      }
    },
    // 获取video，初始化
    getDevices () {
      const _this = this
      AgoraRTC.getDevices(function (items) {
        const videos = items.filter(function (item) {
          return ['videoinput'].indexOf(item.kind) !== -1
        }).map(function (item, index) {
          return {
            name: item.label || 'camera-' + (index + 1),
            value: item.deviceId,
            kind: item.kind
          }
        })
        _this.videos = videos
        const videoIndex = Number(localStorage.getItem('videoIndex'))
        if (videoIndex >= 0) {
          _this.videoId = videos[_this.videoIndex].value
        } else {
          _this.videoId = videos[0].value
          localStorage.setItem('videoIndex', 0)
        }
        _this.init()
      })
    },
    changeVideo() { // 切换摄像头
      const len = this.videos.length
      if (len === 1) {
        this.$message.warning('只有一个摄像头，无法切换')
        return
      }
      this.loading = true
      this.videoIndex++
      if (this.videoIndex >= len) {
        this.videoIndex = 0
      }
      console.log('changeVideo', this.videoIndex, len)
      this.videoId = this.videos[this.videoIndex].value
      this.rtc.localStream.switchDevice('video', this.videoId, this.switchVSussess, this.switchVFail)
    },
    switchVSussess() {
      this.$message.success('切换摄像头成功')
      localStorage.setItem('videoIndex', this.videoIndex)
      this.loading = false
    },
    switchVFail(error) {
      this.loading = false
      const msg = cameraErrorTips[error]
      this.$message.error(`切换摄像头失败，${msg}`)
    },
    // 开始录制视频
    async reportStartVideo() {
      const params = {
        userId: this.userId,
        examId: this.examId
      }
      try {
        this.agoraInfo = await get(`/home/ai-invigilate/start-agora-record`, params)
        if (this.agoraInfo.status === 1) {
          this.errorTimes = 0
          this.statusTimer = null
          // 隔2s后获取录制视频状态是否成功
          this.videoStatusTimer = null
          this.videoStatusTimer = setTimeout(async () => {
            await this.getVideoStatus()
          }, 2000)
        }
        if (this.agoraInfo.status !== 1 && this.errorTimes < 3) {
          this.errorTimes++
          this.statusTimer = null
          this.statusTimer = setTimeout(async () => {
            await this.reportStartVideo()
          }, 1000)
        }
      } catch (e) {
        console.log('start-agora-record', e)
        this.errorTimes = 0
        this.statusTimer = null
        this.videoStatusTimer = null
      }
    },
    // 获取录制视频状态
    async getVideoStatus() {
      const params = {
        channel: this.agoraInfo.channel,
        recordUid: this.agoraInfo.recordUid,
        resourceId: this.agoraInfo.resourceId,
        sid: this.agoraInfo.sid,
        examId: this.examId,
        userId: this.userId
      }
      try {
        this.agoraStatus = await post(`/home/ai-invigilate/get-agora-record`, params)
        if (!this.agoraStatus.fileList && this.errorTimes < 3) { // 失败
          this.errorTimes++
          this.getRecordTimer = null
          this.getRecordTimer = setTimeout(async () => {
            await this.getVideoStatus()
          }, 1000)
        } else {
          this.errorTimes = 0
          this.getRecordTimer = null
        }
      } catch (e) {
        console.log('get-agora-record', e)
        this.errorTimes = 0
        this.getRecordTimer = null
      }
    },
    // 停止视频录制上报
    reportLeave() {
      // start-agora-record 接口返回失败或还没返回情况下不调用 stop-agora-record 接口
      if (this.agoraInfo.status !== 1) {
        return
      }
      const params = {
        channel: this.agoraInfo.channel,
        recordUid: this.agoraInfo.recordUid,
        resourceId: this.agoraInfo.resourceId,
        sid: this.agoraInfo.sid
      }
      post(`/home/ai-invigilate/stop-agora-record`, params)
    },
    // 绘制图片（拍照功能）
    async setImage() {
      const canvas = document.getElementById('canvasAgoraCamera')
      const context = canvas.getContext('2d')
      const id = 'video' + this.option.uid
      const video = document.getElementById(id)
      // 点击，canvas画图
      context.drawImage(video, 0, 0, this.photoWidth, this.photoHeight)
      // 获取图片base64链接
      const image = canvas.toDataURL('image/png')
      // base64转文件
      const file = this.base64ImgtoFile(image)
      // 上传七牛云
      const imgUrl = await qiniuUpload(file, { path: `edu_test/monitorPhoto/${this.examId}` })
      this.$emit('photoReport', imgUrl)
    },
    // base64转文件
    base64ImgtoFile(dataurl, filename = 'cameraImg') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    closeTimer() {
      this.statusTimer = null
      clearInterval(this.photoTimer)
      this.videoStatusTimer = null
      this.getRecordTimer = null
    },
    hexToRgba (hex, opacity) {
      return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    }
  }
}
</script>

<style lang="scss" scoped>
  .video-placeholder {
    position: relative;
    width: 240px;
    height: 160px;
    border-radius: 8px;
    overflow: hidden;
  }
  .video-grid {
    position: relative;
    &:hover {
      .text {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  .text {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 32px;
    // background: rgba(51, 51, 51, 0.8);
    border-radius: 0 0 8px 8px;
    color: #fff;
    font-size: 14px;
    padding-left: 10px;
    visibility: hidden;
    opacity: 0;
    transition: all .3s;
    .icon-camera {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .loading {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);
  }
</style>
